export const scrollHorizontally = () => {

    var scrollAmount = 0;

    var horizontalElementsArray = document.querySelectorAll(
        ".horizontal-block .block__inner"
    );
    Array.from(horizontalElementsArray).forEach((element) => {
        element.classList.add('tjing');
        element.innerHTML = element.innerHTML + '<button class="horizontal-scroll__button  horizontal-scroll__button--previous">tillbaka</button><button class="horizontal-scroll__button  horizontal-scroll__button--next">fram</button>';
        var buttonNext = element.querySelector('.horizontal-scroll__button--next');
        var buttonPrevious = element.querySelector('.horizontal-scroll__button--previous');
        buttonPrevious.classList.add('button-disabled');
        var listElement = element.querySelector('.calendarblock__list');
        var elementCount = listElement.childElementCount;
        var listElementWidth = listElement.offsetWidth;
        var listElementItemWidth = listElement.querySelector('li').offsetWidth;
        var totaltWidth = elementCount * listElementItemWidth;
        //var listElementItem = listElement.querySelector('li');
        //var style = window.getComputedStyle(listElementItem) || listElementItem.currentStyle;
        //var itemMarginRight = style.marginRight;
        //console.log(style.marginRight);
        //console.log(elementCount);
        //console.log(listElementWidth);
        //console.log(totaltWidth);
        buttonNext.onclick = function () {
            var scrollContainer = element.querySelector('.calendarblock__list');
            sideScroll(scrollContainer,'right',50,200,10,elementCount,totaltWidth);
            scrollAmount += (totaltWidth/elementCount);
            //console.log(scrollAmount);
            if((listElementWidth + scrollAmount) >= totaltWidth) {
                buttonNext.classList.add('button-disabled');
                //buttonPrevious.classList.remove('button-disabled');
            }
            if(scrollAmount >= 0) {
                buttonPrevious.classList.remove('button-disabled');
            }
            

        };
        buttonPrevious.onclick = function () {
            var scrollContainer = element.querySelector('.calendarblock__list');
            sideScroll(scrollContainer,'left',50,200,10,elementCount,totaltWidth);
            scrollAmount -= (totaltWidth/elementCount);
            
            //console.log(scrollAmount);
            if((listElementWidth + scrollAmount) <= totaltWidth) {
                buttonNext.classList.remove('button-disabled');
            }
            if(scrollAmount <= 0) {
                buttonPrevious.classList.add('button-disabled');
            }

            
        };
    });
    

    
    function sideScroll(element,direction,speed,distance,step,ecount,totaltWidth){
        var scrollWidth = (totaltWidth/ecount) + 32;
        //console.log(scrollWidth);
        if(direction == 'left'){
            element.scrollLeft -= scrollWidth;
        } else {
            element.scrollLeft += scrollWidth;
        }
        
    }

};